__webpack_require__.p = "https://www.swmc.com/events/";